import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const Datenschutz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-bold text-white mb-2">Datenschutzerklärung</h1>
          <p className="text-slate-500 mb-8 border-b border-slate-800 pb-4">Stand: 2026</p>
        

          <section className="space-y-8">
            <div>
              <h2 className="text-xl font-semibold text-white mb-4">1. Datenschutz auf einen Blick und allgemeine Hinweise</h2>
              <p className="mb-4">
                Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (insbesondere der DSGVO) sowie dieser Datenschutzerklärung. Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
              <p>
                Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht. Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-4">2. Verantwortliche Stelle</h2>
              <p>
                Billy Kittler<br />
                Demminer Straße 17<br />
                13059 Berlin<br />
                E-Mail: ecomcodelab@gmail.com
              </p>
              <p className="mt-4 text-sm text-slate-400">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-4">3. Hosting (Cloudflare Pages)</h2>
              <p className="mb-4">
                Wir hosten unsere Website bei Cloudflare Pages. Anbieter ist die Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA (nachfolgend Cloudflare).
              </p>
              <p className="mb-4">
                Wenn Sie unsere Website besuchen, werden Ihre Anfragen über die Server von Cloudflare geleitet (Content Delivery Network). Dabei werden Verbindungsdaten wie Ihre IP-Adresse an Cloudflare übertragen, um die Website schnell und sicher ausliefern zu können sowie um unsere Website vor Angriffen zu schützen. Die Verwendung von Cloudflare erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst fehlerfreien, schnellen und sicheren Bereitstellung unserer Website.
              </p>
              <p>
                Die Datenübertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission sowie das EU-US Data Privacy Framework (DPF) gestützt, unter welchem Cloudflare zertifiziert ist. Dadurch ist ein angemessenes Datenschutzniveau gemäß europäischen Standards gewährleistet.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-4">4. Datenerfassung auf dieser Website</h2>
              <p className="mb-4">
                <strong>Keine Cookies und keine Analytics:</strong> Diese Website ist eine rein statische Seite. Wir verwenden bewusst keine Cookies, keine Tracker (wie Google Analytics) und keine sonstigen Analyse-Tools, die Informationen auf Ihrem Endgerät speichern oder Ihr Nutzerverhalten auswerten.
              </p>
              <p className="mb-4">
                <strong>Server-Log-Dateien:</strong> Der Provider der Seiten (Cloudflare) erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind in der Regel: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage und IP-Adresse. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
              </p>
              <p>
                <strong>Lokale Schriftarten:</strong> Wir nutzen für die einheitliche Darstellung unserer Website lokal gehostete Schriftarten (z.B. @fontsource). Diese sind direkt auf unserem Server eingebunden. Es findet keine Verbindung zu Servern von Drittanbietern (wie z.B. Google Fonts) statt, sodass hierbei keine IP-Adressen an Dritte übertragen werden.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-white mb-4">5. Ihre Rechte</h2>
              <p className="mb-4">Als Betroffener haben Sie nach der DSGVO umfassende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
              <ul className="list-disc pl-5 space-y-2 text-slate-300">
                <li><strong>Recht auf Auskunft:</strong> Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer bei uns gespeicherten personenbezogenen Daten zu erhalten.</li>
                <li><strong>Recht auf Berichtigung, Sperrung oder Löschung:</strong> Sie haben ein Recht, die Berichtigung, Einschränkung der Verarbeitung oder Löschung dieser Daten zu verlangen, sofern die gesetzlichen Voraussetzungen erfüllt sind.</li>
                <li><strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen.</li>
                <li><strong>Beschwerderecht bei der zuständigen Aufsichtsbehörde:</strong> Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde zu.</li>
              </ul>
            </div>
          </section>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;